import React from 'react';
import theme from './ResidentialUnitEdit.module.scss';
import { Trans } from '@lingui/react/macro';
import { ProjectTag, OptionGroupDto } from '@/types';
import Banner from '@/components/Banner';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { OptionGroupAccordion } from '../../options/OptionGroupAccordion/OptionGroupAccordion';
import { Checkbox } from '@ygtechnologies/rubus-ui';

interface ResidentialUnitEditTagsConfirmProps {
    residentialUnitName: string;
    removedTags: ProjectTag[];
    buyerOptionGroupToUnlinkIds: number[];
    onBuyerOptionGroupToUnlinkIdsChange(v: number[]): void;
    optionGroups: OptionGroupDto[];
}

const ResidentialUnitEditTagsConfirm: React.FC<ResidentialUnitEditTagsConfirmProps> = ({
    residentialUnitName,
    removedTags,
    buyerOptionGroupToUnlinkIds,
    onBuyerOptionGroupToUnlinkIdsChange,
    optionGroups,
}) => {
    const tagNames = removedTags.map((t) => `'${t.label}'`).join(', ');

    return (
        <>
            <p>
                <Trans>
                    You are about to remove <strong> {tagNames}</strong> from {residentialUnitName}. We recommend that you
                    remove any buyer options connected to <strong> {tagNames}</strong>. Failure to do so may result in
                    options relating to rooms that do not exist anymore in that unit.
                </Trans>
            </p>
            <Banner className={theme.bannerMargin} icon={faExclamationCircle} type="info">
                <Trans>
                    <strong>Please note </strong> below are the buyer options connected with the tags{' '}
                    <strong> {tagNames}</strong>. All buyer options, which are connected these tags, are selected by default.
                    If you do not wish to remove a buyer option connected to the tags you are deleting, simply uncheck that
                    buyer option in the list.
                </Trans>
            </Banner>
            <div className={theme.subHeader}>Buyer options to be removed</div>
            <div className={theme.listWrapper}>
                {optionGroups?.map((g) => {
                    const checked = buyerOptionGroupToUnlinkIds.includes(g.id);
                    return (
                        <div key={g.id} className={theme.optionGroupRow}>
                            <Checkbox
                                checked={checked}
                                onChange={(e) =>
                                    onBuyerOptionGroupToUnlinkIdsChange(
                                        e.target.checked
                                            ? [...buyerOptionGroupToUnlinkIds, g.id]
                                            : buyerOptionGroupToUnlinkIds.filter((id) => id !== g.id)
                                    )
                                }
                            />
                            <OptionGroupAccordion accordionVariant="bordered" readonly optionGroup={g} />
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default ResidentialUnitEditTagsConfirm;
